module.exports = __webpack_public_path__ + "img/custom.afa619ca.png";